module.exports = __webpack_public_path__ + "assets/img/index-partner12.e57a64e0.jpg";